// ============================================================
// AUTH TOGGLE — Set to true to re-enable Azure AD authentication
// ============================================================
export const AUTH_ENABLED = true;
